var _path, _path2, _path3, _path4, _circle, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _ellipse, _ellipse2, _ellipse3, _ellipse4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "rocky_1_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "600px",
    height: "600px",
    viewBox: "0 0 600 600",
    enableBackground: "new 0 0 600 600",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "rocky",
    transform: "scale(1.12) translate(-33,0)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "blue_x5F_rim",
    fill: "#7ADFFF",
    d: "M144.6,203.75c-31.95,44.37-95.22,50.65-107.71,167.22 c-9.65,90.07,109.54,120.65,246.15,121.57s212.7-11,259.46-72.43s3.95-145.77-13.47-180.61c-17.42-34.84-37.87-91.68-123.14-114.6 c-71.8-19.3-119.24-41.03-177.82-25.34C168.36,115.56,177.61,157.91,144.6,203.75z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "rock_x5F_base_x5F_color",
    fill: "#868B90",
    d: "M181.84,226.51C158,259.62,99.07,270.29,88.8,357.17s94.4,84.14,196.33,84.83 s158.71-8.21,193.6-54.04s2.95-108.77-10.05-134.76c-13-26-28.26-68.41-91.88-85.51c-53.58-14.4-88.97-30.61-132.68-18.91 C199.57,160.7,206.47,192.3,181.84,226.51z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "rock_x5F_grad1_1_",
    cx: 291.3191,
    cy: 306.6082,
    r: 221.8276,
    fx: 253.8842,
    fy: 357.0853,
    gradientTransform: "matrix(0.9903 -0.1389 -0.1137 -0.8104 37.6973 582.3386)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E8E8E8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EDEDEC",
      stopOpacity: 0
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "rock_x5F_grad1",
    fill: "url(#rock_x5F_grad1_1_)",
    d: "M181.84,226.51C158,259.62,99.07,270.29,88.8,357.17 s94.4,84.14,196.33,84.83s158.71-8.21,193.6-54.04s2.95-108.77-10.05-134.76c-13-26-28.26-68.41-91.88-85.51 c-53.58-14.4-88.97-30.61-132.68-18.91C199.57,160.7,206.47,192.3,181.84,226.51z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "rock_x5F_grad2_1_",
    cx: 291.3191,
    cy: 306.6082,
    r: 236.3089,
    fx: 288.4189,
    fy: 346.2541,
    gradientTransform: "matrix(0.9998 0.0188 0.0115 -0.6115 -3.474 475.3963)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E8E8E8",
      stopOpacity: 0.6
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EDEDEC",
      stopOpacity: 0
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "rock_x5F_grad2",
    fill: "url(#rock_x5F_grad2_1_)",
    d: "M181.84,226.51C158,259.62,99.07,270.29,88.8,357.17 s94.4,84.14,196.33,84.83s158.71-8.21,193.6-54.04s2.95-108.77-10.05-134.76c-13-26-28.26-68.41-91.88-85.51 c-53.58-14.4-88.97-30.61-132.68-18.91C199.57,160.7,206.47,192.3,181.84,226.51z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "rock_x5F_grad3_1_",
    cx: 266.3269,
    cy: 302.4189,
    r: 94.7613,
    gradientTransform: "matrix(1.1307 0 0 -1.1778 -9.8158 617.999)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CFDEE7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#CFDEE7",
      stopOpacity: 0
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "rock_x5F_grad3",
    fill: "url(#rock_x5F_grad3_1_)",
    cx: 291.32,
    cy: 261.81,
    r: 109.31
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "rock_x5F_grad4_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 79.0077,
    y1: 391.8376,
    x2: 372.8064,
    y2: 244.3309,
    gradientTransform: "matrix(1 0 0 -1 0 600)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.224,
    style: {
      stopColor: "#888D93"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    style: {
      stopColor: "#80858B",
      stopOpacity: 0.5856
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6703,
    style: {
      stopColor: "#7B8086",
      stopOpacity: 0
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "rock_x5F_grad4",
    fill: "url(#rock_x5F_grad4_1_)",
    d: "M181.84,226.51C158,259.62,99.07,270.29,88.8,357.17 s94.4,84.14,196.33,84.83s158.71-8.21,193.6-54.04s2.95-108.77-10.05-134.76c-13-26-28.26-68.41-91.88-85.51 c-53.58-14.4-88.97-30.61-132.68-18.91C199.57,160.7,206.47,192.3,181.84,226.51z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "rock_x5F_grad5_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 276.0809,
    y1: 44.4515,
    x2: 300.8268,
    y2: 372.2678,
    gradientTransform: "matrix(1 0 0 -1 0 600)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1598,
    style: {
      stopColor: "#888D93"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5004,
    style: {
      stopColor: "#7B8086",
      stopOpacity: 0
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "rock_x5F_grad5",
    fill: "url(#rock_x5F_grad5_1_)",
    d: "M181.84,226.51C158,259.62,99.07,270.29,88.8,357.17 s94.4,84.14,196.33,84.83s158.71-8.21,193.6-54.04s2.95-108.77-10.05-134.76c-13-26-28.26-68.41-91.88-85.51 c-53.58-14.4-88.97-30.61-132.68-18.91C199.57,160.7,206.47,192.3,181.84,226.51z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "mouth",
    fill: "#404749",
    d: "M288.77,316.47c-8.34,0-15.01-3.94-18.79-11.09c-2.64-4.99-2.98-9.87-3.02-10.41 c-0.17-3.03,2.15-5.63,5.18-5.8c3.03-0.17,5.61,2.13,5.8,5.15c0.13,1.87,1.28,11.16,10.82,11.16c10.15,0,12.05-10.42,12.23-11.61 c0.46-2.99,3.25-5.07,6.24-4.62c2.99,0.44,5.07,3.19,4.65,6.19C310.87,302.71,304.72,316.47,288.77,316.47z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "sunglasses_x5F_color1",
    fill: "#181818",
    d: "M498.8,229.69H333.61c-4.91,0-9.79-0.78-14.49-2.21 c-25.91-7.91-48.87-3-59.22,0.16c-4.54,1.39-9.27,2.05-14.02,2.05H80.81c-8.58,0-15.26,7.4-14.44,15.95 c2.93,30.57,18.83,94.41,100.45,94.41c65.51,0,89.22-41.13,97.76-73.17c1.43-5.38,5.67-9.55,11.07-10.86 c10.13-2.47,19.89-1.67,27.73,0.05c5.64,1.24,10.04,5.57,11.48,11.16c8.19,31.99,31.43,72.82,96.7,72.82 c81.45,0,98.29-63.59,101.67-94.23C514.18,237.22,507.46,229.69,498.8,229.69z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "sunglasses_x5F_color2",
    fill: "#1B2226",
    d: "M99.22,244.32h126.85c10.75,0,18.41,10.33,15.41,20.64 c-6.98,23.94-25.5,60.17-73.68,60.17c-52.15,0-72.44-42.45-79.67-65.82C85.83,251.87,91.42,244.32,99.22,244.32z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "sunglasses_x5F_color3",
    fill: "#2A373F",
    d: "M105.7,244.32h79.92c10.75,0,42.62,0.17,39.7,24.95 c-3.35,28.52-41.56,36.8-71.01,33.54c-33.05-3.66-52.47-20.12-59.69-43.49C92.3,251.87,97.89,244.32,105.7,244.32z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "sunglasses_x5F_color2_1_",
    fill: "#1B2226",
    d: "M478.91,244.32H352.07c-10.75,0-18.41,10.33-15.41,20.64 c6.98,23.94,25.5,60.17,73.68,60.17c52.15,0,72.44-42.45,79.67-65.82C492.31,251.87,486.72,244.32,478.91,244.32z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "sunglasses_x5F_color3_1_",
    fill: "#2A373F",
    d: "M368.1,244.32h65.27c10.75,0,31.33,4.11,31.33,24.95 c0,22.87-40.7,36.8-70.16,33.54c-33.05-3.66-53.78-19.48-49.11-43.49C347.43,249.04,360.29,244.32,368.1,244.32z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "sunglasses_x5F_color4",
    fill: "#FFC71E",
    cx: 127.06,
    cy: 261.93,
    rx: 19.61,
    ry: 11.87
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    id: "sunglasses_x5F_color4_1_",
    fill: "#FFC71E",
    cx: 212.14,
    cy: 273.55,
    rx: 13.36,
    ry: 8.09
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    id: "sunglasses_x5F_color4_2_",
    fill: "#FFC71E",
    cx: 368.87,
    cy: 261.81,
    rx: 18.49,
    ry: 11.74
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    id: "sunglasses_x5F_color4_3_",
    fill: "#FFC71E",
    cx: 442.25,
    cy: 272.28,
    rx: 9.76,
    ry: 6.82
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.bc566569893319a6858162044e78fd50.svg";
export { ForwardRef as ReactComponent };